export default class MCheckout {
    constructor(stripeAPIKey, paymentElementId, clientSecretRoute, stripeLocale = 'it') {
        this.stripeAPIKey = stripeAPIKey;
        this.stripe = Stripe(this.stripeAPIKey, {
            locale: stripeLocale
        });
        this.paymentElementId = paymentElementId;
        this.clientSecretRoute = clientSecretRoute;

        this.initialize().then(async () => {
            let paymentIntent = await this.paymentIntent;
            let cardElement = await this.cardElement;
            this.afterInited(paymentIntent, cardElement);
        });
    }

    afterInited = (paymentIntent, cardElement) => {
        // overwrite this function to operate after class inited
    }

    getStripePaymentIntent = async (items) => {
        if (await this.paymentIntent) {
            return this.paymentIntent;
        } else {
            return await fetch(this.clientSecretRoute, {
                method: "POST",
                headers: { "Content-Type": "application/json", "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content') },
                body: JSON.stringify({ items }),
            }).then((r) => r.json());
        }
    }

    // Fetches a payment intent and captures the client secret
    initialize = async () => {
        var _this = this;
        
        var itemsElements = $("[name='items[]']");
        const items = _.map(itemsElements, function(val) {
            return {
                item_id: $(val).val()
            };
        });
        
        this.paymentIntent = this.getStripePaymentIntent(items);

        this.elements = this.stripe.elements({ 
            fonts: [{
                // integrate your font into stripe
                cssSrc: 'https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
            }]
        });
        let style = {
            base: {
                color: '#24252B',
                fontFamily: '"DM Sans", sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#6C7176'
                }
            },
            invalid: {
                color: '#FF4949',
                iconColor: '#FF4949'
            }
        };

        this.cardElement = this.elements.create("card", {
            hidePostalCode: true,
            style: style
        });
        this.cardElement.mount(this.paymentElementId);
        this.cardElement.on('change', function(event) {
            if (event.error) {
                _this.showStripeCardErrors(event.error.message);
            } else {
                _this.showStripeCardErrors('');
            }
        });
    }

    createStripePaymentMethod = async (billingDetails, successCallback) => {
        var _this = this;
        this.setLoading(true);
        this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardElement,
            billing_details: billingDetails    
        }).then((result) => {
            if (result.error) {
                // Show error to your customer (for example, insufficient funds)
                _this.showStripeCardErrors(result.error.message);
            } else {
                if (result.paymentMethod && result.paymentMethod.id) {
                    _this.paymentMethod = result.paymentMethod;
                    successCallback(_this.paymentMethod);
                } else {
                    _this.showStripeCardErrors('Non siamo riusciti a creare un metodo di pagamento');
                    _this.setLoading(false);
                }
            }
        });
    }

    confirmCardPayment = async (billingDetails, receipt_email, successCallback) => {
        var _this = this;
        this.setLoading(true);
    
        let paymentIntent = await this.paymentIntent;
        var clientSecret = paymentIntent.clientSecret;
        var customerId = paymentIntent.customerId;
        this.stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: this.cardElement,
                billing_details: billingDetails
            },
            receipt_email: receipt_email
        }).then(function(result) {
            if (result.error) {
                // Show error to your customer (for example, insufficient funds)
                _this.showStripeCardErrors(result.error.message);
            } else {
                // The payment has been processed!
                if (result.paymentIntent.status === 'succeeded') {
                    // Show success modal
                    _this.showStripeCardErrors('');
                    successCallback(result.paymentIntent, customerId);
                }
            }
            _this.setLoading(false);
        });
    }

    showStripeCardErrors = (errorMessage) => {
        var displayError = document.querySelector(this.paymentElementId + '-errors');
        displayError.textContent = errorMessage;
    }

    // Show a spinner on payment submission
    setLoading = (isLoading) => {
        if (isLoading) {
            // Disable the button and show a spinner
            document.querySelector("#payNowButton").disabled = true;
            document.querySelector("#spinner").classList.remove("d-none");
            document.querySelector("#button-text").classList.add("d-none");
        } else {
            document.querySelector("#payNowButton").disabled = false;
            document.querySelector("#spinner").classList.add("d-none");
            document.querySelector("#button-text").classList.remove("d-none");
        }
    }
}